import { ActionError, PromisifiedActionMeta } from 'Interfaces/ActionCreators';
import { Company } from 'Interfaces/User';
import { createAction, createAsyncAction } from 'typesafe-actions';
import { promisifyAsyncAction } from 'Utils/functions';

import { GetCompanyInfoActionTypes, redirectToBillingType } from './actionTypes';

export const redirectToBilling = createAction(redirectToBillingType)<boolean>();

export const getCompanyInfo = createAsyncAction(
  GetCompanyInfoActionTypes.request,
  GetCompanyInfoActionTypes.success,
  GetCompanyInfoActionTypes.failure,
  GetCompanyInfoActionTypes.cancel,
)<
  [undefined, PromisifiedActionMeta],
  [Company, PromisifiedActionMeta],
  [ActionError, PromisifiedActionMeta],
  [undefined, PromisifiedActionMeta]
>();

export const $getCompanyInfo = promisifyAsyncAction(getCompanyInfo);
